export enum MenuType {
  BRAND,
  LEFT,
  RIGHT
}

export interface RouteInfo {
  path: string;
  title: string;
  menuType: MenuType;
}



// WEBPACK FOOTER //
// ./src/app/components/navbar/navbar.metadata.ts